import { render, staticRenderFns } from "./PatientProfilePage.vue?vue&type=template&id=6cbd0f4b&scoped=true"
import script from "./PatientProfilePage.vue?vue&type=script&lang=js"
export * from "./PatientProfilePage.vue?vue&type=script&lang=js"
import style0 from "./PatientProfilePage.vue?vue&type=style&index=0&id=6cbd0f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd0f4b",
  null
  
)

export default component.exports